import { makeAutoObservable } from 'mobx'
import { type IResponseFilters } from 'entities/Contacts/api/filterTypes'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { FilterEditorStore } from 'widgets/FilterEditor'
import { type IExcludeFilter } from 'widgets/FilterEditor/types/types'

type IFiltersStoreProps = {
  getFilters: () => Promise<IResponseFilters>
  hideFilters?: boolean
  excludeFilters?: IExcludeFilter
}

export class FiltersAndSearchStore {
  private _filterEditorStore: FilterEditorStore

  constructor(
    { getFilters, hideFilters, excludeFilters }: IFiltersStoreProps,
    private _entities: IEntitiesStore
  ) {
    makeAutoObservable(this)

    this._filterEditorStore = new FilterEditorStore(
      {
        makeRequest: () => {
          return getFilters()
        },
        showSpawned: true,
        excludeFilters: excludeFilters,
      },
      this._entities
    )

    this._hideFilters = !!hideFilters
  }

  private _opened = false
  private _search = ''
  private _hideFilters = false

  loadFilters = () => this._filterEditorStore.initFilters()

  get opened() {
    return this._opened
  }

  get hideFilters() {
    return this._hideFilters
  }

  get search() {
    return this._search
  }

  get filterEditorStore() {
    return this._filterEditorStore
  }

  get params() {
    return {
      search: this._search,
      filtersList: this.noEmptyFilters,
    }
  }

  get noEmptyFilters() {
    return this._filterEditorStore.groups.toSegment().paramsFilterSegment
  }

  get hasSearchParams() {
    return !!this._search.trim() || !!this._filterEditorStore.groups.count
  }

  handleSearch = (value: string) => {
    this._search = value
  }

  reset = () => {
    this._search = ''
    this._filterEditorStore.dispose()
  }

  onOpen = (condition: boolean) => {
    this._opened = condition
  }
}
